const cssTable = {
    '.ant-table-cell': {
        whiteSpace: 'nowrap',
        textAlign: 'left',
    },

    // 增加表格头样式
    '.ant-table-thead > tr >th': {
        fontWeight: 'bold',
    },

    width: '100vw',
    height: 'calc(100vh - 240px)'
}

export default cssTable;